var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecHired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.3337C14.6025 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6025 1.66699 10.0001 1.66699C5.39771 1.66699 1.66675 5.39795 1.66675 10.0003C1.66675 14.6027 5.39771 18.3337 10.0001 18.3337ZM13.8617 8.65356C14.2684 8.24677 14.2684 7.58722 13.8617 7.18042C13.4549 6.77363 12.7953 6.77363 12.3885 7.18042L8.95841 10.6105L7.61165 9.26376C7.20485 8.85696 6.54531 8.85696 6.13851 9.26376C5.73172 9.67055 5.73172 10.3301 6.13851 10.7369L8.22185 12.8202C8.62864 13.227 9.28819 13.227 9.69498 12.8202L13.8617 8.65356Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecHired);
export default __webpack_public_path__ + "static/media/rec-hired.909fd32ea3e8ad876ee294a9b14fb15e.svg";
export { ForwardRef as ReactComponent };